<div class="ui selection fluid dropdown" #meetingTypeDropdown>
    <input type="hidden" name="type" value="default" />
    <i class="dropdown icon"></i>
    <div class="default text">Meeting Type</div>
</div>

<div class="share">
    <ng-container *ngIf="meetingTypes; else showLoader">
        <div class="item share__link">
            <i class="icon linkify"></i>
            <!-- TODO: Add CNAME updates when it is merged -->
            <a href="https://calendarhero.to/{{ meetingTypes[selected].ondemand.value }}" target="_blank"
                >calendarhero.to/{{ meetingTypes[selected].ondemand.value }}</a
            >
            <button
                class="ui button icon button--copy"
                (click)="copyText('https://calendarhero.to/' + meetingTypes[selected].ondemand.value)"
            >
                <i class="icon copy outline" data-content="Copy"></i>
            </button>
        </div>

        <div class="item share__time">
            <i class="icon clock outline"></i>
            {{ meetingTypes[selected].startHour?.value | stringTimeToDate | date: "h:mmaaaaa'm'" }} -
            {{ meetingTypes[selected].endHour?.value | stringTimeToDate | date: "h:mmaaaaa'm'" }},
            {{ meetingTypes[selected].meetingLength?.value | durationTime: 'simple' }} duration<ng-container
                *ngIf="
                    meetingTypes[selected].noticePeriodMinutes?.value &&
                    meetingTypes[selected].noticePeriodMinutes.value !== '0'
                "
                >,
                {{ meetingTypes[selected].noticePeriodMinutes.value | durationTime: 'simple' }}
                lead time
            </ng-container>
        </div>

        <div class="item share__dates">
            <i class="icon calendar alternate outline"></i>
            <div class="dates__day">
                <ng-container *ngFor="let day of daysOfWeek; index as i">
                    <span *ngIf="meetingTypes[selected].availabilityWindows.value[day].length > 0">{{
                        day | titlecase
                    }}</span
                    ><span *ngIf="meetingTypes[selected].availabilityWindows.value[day].length > 0" class="comma"
                        >,
                    </span>
                </ng-container>
            </div>
        </div>

        <div class="item share__video" *ngIf="meetingTypes[selected].videoProviderObj?.type">
            <i class="icon video"></i>
            {{ meetingTypes[selected].videoProviderObj?.type | titlecase }}
        </div>

        <div class="share__actions">
            <button
                class="ui button primary"
                (click)="copyText('https://calendarhero.to/' + meetingTypes[selected].ondemand.value)"
            >
                Share Scheduling Link
            </button>

            <button class="ui button secondary" (click)="handleGetSuggestedTimes(selected)">
                Share Available Times
            </button>
        </div>

        <div class="ui fullscreen modal" id="copyTimesModal">
            <div class="header">Preview times to be copied</div>
            <div class="add-times-segment">
                <div class="content" [innerHTML]="addTimesHTML | safeHtml"></div>
            </div>
            <div class="actions">
                <button class="ui cancel button">Cancel</button>
                <button class="ui approve primary button">Copy times to clipboard</button>
            </div>
        </div>
    </ng-container>
</div>
<ng-template #showLoader>
    <div class="ui active inverted dimmer">
        <div class="ui text loader">Loading...</div>
    </div>
</ng-template>
